import React, { Component } from 'react';
import styled from 'styled-components';
import ErrorMessage from '@zocdoc-frontend-common/components-errormessage';
import Textbox from '@zocdoc-frontend-common/components-textbox';
import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import { Column, Row } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import { blue100, red80 } from '@zocdoc-mezzanine/foundations-colors';

/**
 * @param {string} defaultFirst
 * @param {string} defaultLast
 * @param {boolean} error
 * @param {function(): void} onBlur
 * @param {function(): void} onChange
 * @param {function(): void} onFocus
 * @returns {JSX.Element}
 * @constructor
 */
export default class NameFields extends Component {
    render() {
        const { onFocus, onBlur, onChange, error, defaultFirst, defaultLast } =
            this.props;
        return (
            <FormRow>
                <FormLabel>Your name</FormLabel>
                <Row>
                    <Column size={12}>
                        <StyledFirstNameTextBox
                            className="exclude-from-playback"
                            data-test="first-name"
                            data-uem-id="firstname"
                            invalid={error}
                            onChange={(e) => {
                                onChange('firstName', e.target.value);
                            }}
                            onBlur={(e) => {
                                onBlur('firstName', e.target.value);
                            }}
                            onFocus={() => {
                                onFocus('firstName');
                            }}
                            placeholder="First"
                            defaultValue={defaultFirst}
                        />
                    </Column>
                    <Column size={12}>
                        <StyledTextBox
                            className="exclude-from-playback"
                            data-test="last-name"
                            data-uem-id="lastname"
                            invalidMessage={error}
                            onChange={(e) => {
                                onChange('lastName', e.target.value);
                            }}
                            onBlur={(e) => {
                                onBlur('lastName', e.target.value);
                            }}
                            onFocus={() => {
                                onFocus('lastName');
                            }}
                            placeholder="Last"
                            defaultValue={defaultLast}
                        />
                    </Column>
                </Row>
                {this.maybeRenderErrorMessage()}
            </FormRow>
        );
    }

    maybeRenderErrorMessage = () => {
        const { error } = this.props;

        if (error) {
            return (
                <Row>
                    <ErrorMessage data-test="name-error">
                        Please type a name.
                    </ErrorMessage>
                </Row>
            );
        }
    };
}

const StyledTextBox = styled(Textbox)`
    min-width: 0;
    ${(p) => (p.invalid ? `border-color: ${red80}` : '')};
`;

const StyledFirstNameTextBox = styled(StyledTextBox)`
    border-right: none;
    &:focus {
        border-right: solid;
        border-right-width: 1px;
        border-right-color: ${blue100};
    }
`;

const FormLabel = styled.div`
    color: ${blue100};
    font: 15px/24px ${FontFamily.SharpSansSemibold};
`;
